'use client'

import { FirestoreUserWorkspacesListFetch } from '../FirestoreUserWorkspacesListFetch'

const RootStoreManager = () => {
  return <FirestoreUserWorkspacesListFetch />
}

export { RootStoreManager }
